import createIcon from '../../createIcon';

/**
 * @component @name AllOut
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgNEwyMCA4VjRIMTZaTTIwIDE2TDE2IDIwSDIwVjE2Wk04IDIwTDQgMTZWMjBIOFpNNCA4TDggNEg0VjhaTTE2Ljk1IDcuMDVDMTQuMjIgNC4zMiA5Ljc4IDQuMzIgNy4wNSA3LjA1QzQuMzIgOS43OCA0LjMyIDE0LjIyIDcuMDUgMTYuOTVDOS43OCAxOS42OCAxNC4yMiAxOS42OCAxNi45NSAxNi45NUMxOS42OCAxNC4yMiAxOS42OCA5Ljc5IDE2Ljk1IDcuMDVaTTE1Ljg1IDE1Ljg1QzEzLjcyIDE3Ljk4IDEwLjI4IDE3Ljk4IDguMTUgMTUuODVDNi4wMiAxMy43MiA2LjAyIDEwLjI4IDguMTUgOC4xNUMxMC4yOCA2LjAyIDEzLjcyIDYuMDIgMTUuODUgOC4xNUMxNy45OCAxMC4yOCAxNy45OCAxMy43MiAxNS44NSAxNS44NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AllOut = createIcon('AllOut', [
  [
    'path',
    {
      d: 'M16 4L20 8V4H16ZM20 16L16 20H20V16ZM8 20L4 16V20H8ZM4 8L8 4H4V8ZM16.95 7.05C14.22 4.32 9.78 4.32 7.05 7.05C4.32 9.78 4.32 14.22 7.05 16.95C9.78 19.68 14.22 19.68 16.95 16.95C19.68 14.22 19.68 9.79 16.95 7.05ZM15.85 15.85C13.72 17.98 10.28 17.98 8.15 15.85C6.02 13.72 6.02 10.28 8.15 8.15C10.28 6.02 13.72 6.02 15.85 8.15C17.98 10.28 17.98 13.72 15.85 15.85Z',
      key: '1djg9o',
    },
  ],
]);

export default AllOut;
